import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import altelis_logo from "../../assets/images/altelis-full.svg";
import not_found from "../../assets/images/order-404.svg";
import valid from "../../assets/images/valid-subscription.png";
import { CircularProgress, TextField } from "@mui/material";
import axios from "axios";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/fr";
import { toast } from "react-toastify";
import toastOptions from "../../assets/constants/toast";
import { CursorClickIcon } from "@phosphor-icons/react";
import CustomTag from "../../ui/CustomTag";
import "../../assets/css/pages/tests/test-subscribe.css";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("fr");
dayjs.tz.setDefault("Europe/Paris");

const TestSubscribe = () => {
    const { testId } = useParams();
    const [buttonLoading, setButtonLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasSubscribed, setHasSubscribed] = useState(false);
    const [subscription, setSubscription] = useState({
        startDate: dayjs().tz("Europe/Paris").add(1, "hour").startOf("hour"),
    });
    const [error, setError] = useState(false);
    const [test, setTest] = useState(null);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_UPA_API_HOST}tests/${testId}/public`)
            .then((response) => {
                if (response.data && response.data.name) {
                    setTest(response.data);
                } else {
                    setError(true);
                }
                setIsLoaded(true);
            })
            .catch(() => {
                setError(true);
                setIsLoaded(true);
            });
    }, [testId]);

    const handleSubscribe = () => {
        setButtonLoading(true);
        axios
            .post(`${process.env.REACT_APP_UPA_API_HOST}tests/subscribe`, {
                ...subscription,
                startDate: subscription.startDate.subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss"),
                testId: test.id,
            })
            .then(() => {
                setButtonLoading(false);
                setHasSubscribed(true);
            })
            .catch((err) => {
                toast.error(err.response.data.message, toastOptions);
                setButtonLoading(false);
            });
    };

    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    return isLoaded ? (
        !error ? (
            <div className="test-subscribe">
                {dayjs().tz("Europe/Paris").isAfter(dayjs(test.startDate).tz("Europe/Paris")) && dayjs().tz("Europe/Paris").isBefore(dayjs(test.stopDate).tz("Europe/Paris")) ? (
                    !hasSubscribed ? (
                        <div className="test-subscribe__main">
                            <div className="test-subscribe__left">
                                <div className="test-subscribe__left-content">
                                    <h1>{test.name}</h1>
                                    <p>Rejoignez notre équipe en passant ce test de recrutement. Montrez-nous vos compétences et votre motivation.</p>
                                    <CustomTag value={test.id} />
                                </div>
                            </div>
                            <div className="test-subscribe__right">
                                <div className="test-subscribe__header">
                                    <img src={altelis_logo} alt="Altelis" className="test-subscribe__logo" />
                                    <div className="test-subscribe__contact-info">
                                        <CustomTag value="phone" label="01 85 09 74 06" />
                                        <CustomTag value="email" label="candidature@altelis.com" />
                                    </div>
                                </div>
                                
                                <div className="test-subscribe__intro">
                                    <h1>Inscription au test</h1>
                                    <p>Complétez le formulaire ci-dessous pour vous inscrire au test de candidature.</p>
                                </div>

                                <div className="test-subscribe__duration">
                                    <span className="test-subscribe__duration-label">Durée du test</span>
                                    <div className="test-subscribe__duration-value">
                                        {test.hours > 0 && `${test.hours} heure${test.hours > 1 ? "s" : ""}`}
                                        {test.hours > 0 && test.minutes > 0 && " et "}
                                        {test.minutes > 0 && `${test.minutes} minute${test.minutes > 1 ? "s" : ""}`}
                                    </div>
                                </div>
                                <div className="c-modal-content">
                                    <div className="custom__modal-group">
                                        <label className="name">Créneau de passage <span className="required-asterisk">*</span></label>
                                        <DateTimePicker
                                            ampm={false}
                                            minDateTime={dayjs().isAfter(dayjs(test.startDate)) ? dayjs() : dayjs(test.startDate)}
                                            maxDateTime={dayjs(test.stopDate).tz("Europe/Paris").subtract(1, "day").endOf("day").subtract(test.hours, "hours").subtract(test.minutes, "minutes")}
                                            disableMaskedInput
                                            value={subscription.startDate}
                                            format="DD MMMM YYYY à HH:mm"
                                            onChange={(newValue) =>
                                                setSubscription({
                                                    ...subscription,
                                                    startDate: newValue,
                                                })
                                            }
                                            textField={(params) => (
                                                <TextField
                                                    {...params}
                                                    className="classic-input"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        readOnly: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    {subscription.startDate && (
                                        <div className="test-subscribe__slot-preview">
                                            <div className="test-subscribe__slot-text">
                                                Votre test sera programmé pour le{" "}
                                                <span className="test-subscribe__slot-time">
                                                    {subscription.startDate.format("DD MMMM YYYY")} de {subscription.startDate.format("HH:mm")} à{" "}
                                                    {subscription.startDate.add(test.hours, "hour").add(test.minutes, "minute").format("HH:mm")}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    <div className="test-subscribe__form-group--row">
                                        <div className="custom__modal-group">
                                            <label className="name">Prénom <span className="required-asterisk">*</span></label>
                                            <input
                                                type="text"
                                                className="classic-input"
                                                placeholder="Votre prénom"
                                                value={subscription.firstName || ""}
                                                onChange={(e) =>
                                                    setSubscription({
                                                        ...subscription,
                                                        firstName: capitalize(e.target.value),
                                                    })
                                                }
                                                required
                                            />
                                        </div>
                                        <div className="custom__modal-group">
                                            <label className="name">Nom <span className="required-asterisk">*</span></label>
                                            <input
                                                type="text"
                                                className="classic-input"
                                                placeholder="Votre nom"
                                                value={subscription.lastName || ""}
                                                onChange={(e) =>
                                                    setSubscription({
                                                        ...subscription,
                                                        lastName: e.target.value.toUpperCase(),
                                                    })
                                                }
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="custom__modal-group">
                                        <label className="mail">Adresse email <span className="required-asterisk">*</span></label>
                                        <input
                                            type="email"
                                            className="classic-input"
                                            placeholder="votre.email@exemple.com"
                                            value={subscription.email || ""}
                                            onChange={(e) =>
                                                setSubscription({
                                                    ...subscription,
                                                    email: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                    </div>
                                    <div className="test-subscribe__submit">
                                        {buttonLoading ? (
                                            <button className="button-large blue-button" disabled>
                                                <CircularProgress size={16} className="white-loader" />
                                                <span>Inscription...</span>
                                            </button>
                                        ) : (
                                            <button className="button-large blue-button" onClick={handleSubscribe}>
                                                <CursorClickIcon size={16} weight="bold" />
                                                <span>Valider mon inscription</span>
                                            </button>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="test-subscribe__main">
                            <div className="test-subscribe__left">
                                <div className="test-subscribe__left-content">
                                    <h1>Inscription validée !</h1>
                                    <p>Votre demande a été transmise avec succès. Consultez votre boîte mail pour les prochaines étapes.</p>
                                    <CustomTag value="success" label="Test confirmé" />
                                </div>
                            </div>
                            <div className="test-subscribe__right">
                                <div className="test-subscribe__header">
                                    <img src={altelis_logo} alt="Altelis" className="test-subscribe__logo" />
                                    <div className="test-subscribe__contact-info">
                                        <CustomTag value="phone" label="01 85 09 74 06" />
                                        <CustomTag value="email" label="candidature@altelis.com" />
                                    </div>
                                </div>
                                
                                <div className="test-subscribe__success-content">
                                    <div className="test-subscribe__success-icon">
                                        <img src={valid} alt="Inscription réussie" width={80} />
                                    </div>
                                    
                                    <div className="test-subscribe__success-info">
                                        <h1>Inscription réussie !</h1>
                                        <p>Votre demande de test a bien été enregistrée. Vous recevrez une convocation par email contenant toutes les informations relatives au test.</p>
                                        
                                        <div className="test-subscribe__next-steps">
                                            <h3>Prochaines étapes :</h3>
                                            <ul>
                                                <li>Vérifiez votre boîte mail (y compris les spams)</li>
                                                <li>Préparez votre environnement de test</li>
                                                <li>Contactez-nous en cas de question</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                ) : (
                    <div className="test-subscribe__main error">
                        <div className="test-subscribe__card">
                            <div className="test-subscribe__error">
                                <img src={not_found} alt="Test non disponible" width={280} />
                                <h1>Oups...</h1>
                                <p>
                                    Ce test n'est disponible que du <strong className="test-subscribe__error-period">{dayjs(test.startDate).tz("Europe/Paris").format("DD MMMM YYYY")}</strong> au{" "}
                                    <strong className="test-subscribe__error-period">{dayjs(test.stopDate).tz("Europe/Paris").subtract(1, "day").format("DD MMMM YYYY")} à 23h59</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        ) : (
            <div className="test-subscribe__main error">
                <div className="test-subscribe__card">
                    <div className="test-subscribe__error">
                        <img src={not_found} alt="Test introuvable" width={280} />
                        <h1>Oups...</h1>
                        <p>Le test que vous cherchez n'est pas disponible pour le moment. Merci de réessayer plus tard.</p>
                    </div>
                </div>
            </div>
        )
    ) : (
        <div className="test-subscribe">
            <div className="test-subscribe__main">
                <div className="test-subscribe__card" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "20rem" }}>
                    <CircularProgress size={30} style={{ color: "var(--blue-500)" }} />
                </div>
            </div>
        </div>
    );
};

export default TestSubscribe;
